import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { quickBigSearch } from './Reducers/QuickBigSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from './Reducers/FacetedSearch.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { messageBanners } from './Reducers/MessageBanners.reducer';
import { dropZone } from './Reducers/DropZone.reducer';
import { loadingSpinner } from './Reducers/LoadingSpinner.reducer';
import { customerPrices } from './Reducers/CustomerPrices.reducer';
import { quantityInput } from './Reducers/QuantityInput.reducer';

const staticReducers = {
    cart,
    quickSearch,
    navigation,
    facetedSearch,
    checkout,
    myPage,
    messageBanners,
    dropZone,
    quickBigSearch,
    loadingSpinner,
    customerPrices,
    quantityInput
};

const app = combineReducers(staticReducers);

export const createReducer = (asyncReducers) => {
    return combineReducers({
        ...staticReducers,
        ...asyncReducers,
    });
};

export default app;
